export function permanentProjectLinks() {
    var hash = window.location.hash;
    console.log(hash);
    if (hash && $(hash).length) {
        console.log (hash);
        $('#overview').removeClass('active');
        $('#overview-content').removeClass('active');
        $(hash).addClass('active');
        $(hash + '-content').addClass('active');
        window.scrollTo(0, 0);
    };
}



// WEBPACK FOOTER //
// ./assets/js/modules/permanentProjectLinks.js